import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div #overlay class="confirm-dialog-overlay" (click)="onOverlayClick()" (keydown)="onKeyDown($event)" tabindex="-1">
      <div class="confirm-dialog-container" (click)="$event.stopPropagation()">
        <div class="confirm-dialog-header">
          <div class="confirm-dialog-icon">
            <mat-icon>warning</mat-icon>
          </div>
          <h3 class="confirm-dialog-title">{{ title }}</h3>
        </div>
        <div class="confirm-dialog-body">
          <p>{{ message }}</p>
        </div>
        <div class="confirm-dialog-footer">
          <button class="btn btn-secondary" (click)="onCancel($event)">Annuler</button>
          <button class="btn btn-primary" (click)="onConfirm($event)">{{ confirmLabel }}</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .confirm-dialog-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.75);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100000;
      pointer-events: auto;
    }
    .confirm-dialog-container {
      background: white;
      border-radius: 12px;
      padding: 1.5rem;
      width: 90%;
      max-width: 450px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3);
      z-index: 100001;
      pointer-events: auto;
    }
    .confirm-dialog-header {
      margin-bottom: 1rem;
      text-align: center;
    }
    .confirm-dialog-icon {
      color: #f59e0b;
      margin-bottom: 1rem;
    }
    .confirm-dialog-icon mat-icon {
      font-size: 3rem;
      width: 3rem;
      height: 3rem;
    }
    .confirm-dialog-title {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: #1e293b;
    }
    .confirm-dialog-body {
      margin-bottom: 2rem;
      text-align: center;
      color: #475569;
      font-size: 1.1rem;
    }
    .confirm-dialog-footer {
      display: flex;
      gap: 1rem;
      justify-content: center;
    }
    .btn {
      padding: 0.75rem 1.5rem;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      border: 1px solid transparent;
      font-size: 1rem;
      min-width: 120px;
    }
    .btn-secondary {
      background-color: #f1f5f9;
      color: #475569;
      border-color: #e2e8f0;
    }
    .btn-secondary:hover {
      background-color: #e2e8f0;
    }
    .btn-primary {
      background-color: #ef4444;
      color: white;
    }
    .btn-primary:hover {
      background-color: #dc2626;
    }
  `]
})
export class ConfirmDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('overlay', { static: true }) overlay?: ElementRef<HTMLElement>;

  @Input() title: string = 'Confirmation';
  @Input() message: string = 'Êtes-vous sûr de vouloir effectuer cette action ?';
  @Input() confirmLabel: string = 'Supprimer';

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  ngOnInit() {
    console.log('ConfirmDialogComponent: Initialized', { title: this.title, message: this.message });
  }

  ngAfterViewInit() {
    this.overlay?.nativeElement.focus();
  }

  onConfirm(event: Event) {
    event.stopPropagation();
    console.log('ConfirmDialogComponent: Confirm clicked');
    this.confirmed.emit();
  }

  onCancel(event: Event) {
    event.stopPropagation();
    console.log('ConfirmDialogComponent: Cancel clicked');
    this.cancelled.emit();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key !== 'Enter') {
      return;
    }
    if (event.target instanceof HTMLButtonElement) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    console.log('ConfirmDialogComponent: Enter pressed');
    this.confirmed.emit();
  }

  onOverlayClick() {
    console.log('ConfirmDialogComponent: Overlay clicked');
    this.cancelled.emit();
  }
}
